
import React, { useState } from 'react';
import TagManager from 'react-gtm-module';
import './CookieAgreement.scss';

const COOKIE_AGREED_KEY = 'cookie-agreed';

const enableGoogleTagManager = () => {
  if (!(window as any).tagManagerInitialized && process.env.REACT_APP_ENV === 'production') {
    const tagManagerArgs = {
      gtmId: 'GTM-W4Q4SQ9'
    };
    TagManager.initialize(tagManagerArgs);
    (window as any).tagManagerInitialized = true;
  }
};

export function CookieAgreement() {

  const [isAlreadyAgreed, setAlreadyAgreed] = useState(!!localStorage.getItem(COOKIE_AGREED_KEY));
  const [showMore, setShowMore] = useState(false);

  const setAgreed = () => {
    localStorage.setItem(COOKIE_AGREED_KEY, 'true');
    setAlreadyAgreed(true);
  }

  if (isAlreadyAgreed) {
    enableGoogleTagManager();
    return null;
  }
  return (
    <div className='cookie-agreement'>
      <div className='overlay'></div>
      <div className='cookie-agreement__more-info' hidden={!showMore}>
        Kasutame küpsiseid sisu ja reklaamide isikupärastamiseks, sotsiaalmeedia funktsioonide pakkumiseks ja liikluse analüüsimiseks. Samuti jagame teavet meie saidi kasutamise kohta oma sotsiaalmeedia, reklaami- ja analüüsipartneritega, kes võivad seda kombineerida muu teabega, mille olete neile edastanud või mille nad on kogunud teilt nende teenuste kasutamisel.
      </div>      
      <div className='d-flex flex-column flex-md-row align-items-center justify-content-center'>
        <div>
          Sellel veebilehel kasutatakse küpsiseid. Veebilehe kasutamist jätkates nõustute küpsiste kasutamisega.
        </div>
        <div className='d-flex align-items-center mt-2 mt-md-0'>
          <button className='btn btn-outline-light ml-3 text-nowrap' onClick={() => setShowMore(!showMore)}>
            { showMore ? 'Peida lisainfo' : 'Loe rohkem' }
          </button>
          <button className='btn btn-light ml-3' onClick={() => setAgreed()}>
            Nõustu
          </button>
        </div>
      </div>
    </div>
  )
}